module.exports = function AccessibleMenu() {
    var button = document.querySelector('.main-menu-icon');
    var header = document.querySelector('.header-upper');
    var content = document.querySelector('.header-content');
    if (!button || !header || !content) return;
    var mobile = window.matchMedia('(max-width: 900px)');
    function setOpen(open, restoreFocus) {
        header.classList.toggle('is-open', open);
        button.setAttribute('aria-expanded', String(open));
        button.setAttribute('aria-label', open ? 'Stäng meny' : 'Öppna meny');
        if (restoreFocus) button.focus();
    }
    button.addEventListener('click', function () {
        setOpen(button.getAttribute('aria-expanded') !== 'true');
    });
    header.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && button.getAttribute('aria-expanded') === 'true') {
            setOpen(false, true);
        }
    });
    mobile.addEventListener('change', function () { setOpen(false); });
    setOpen(false);
};
